/* eslint-disable */
const colleagueNameRule = [
    {
        type: 'key',
        value: 'name'
    },
    {
        type: 'tag',
        value: '<span>'
    },
    {
        type: 'string',
        value: ' ('
    },
    {
        type: 'key',
        value: 'options.colleagueInfo.account'
    },
    {
        type: 'string',
        value: ')'
    },
    {
        type: 'tag',
        value: '</span>'
    }
];

const recentNameRule = [
    {
        type: 'key',
        value: 'name'
    },
    {
        type: 'tag',
        value: '<span>'
    },
    {
        type: 'function',
        value: item => {
            let result = '';
            switch (item.sourceType) {
                case 'people':
                    if (item.colleagueInfo && item.colleagueInfo.account) {
                        result = item.colleagueInfo.account;
                    } else {
                        result = item.encodeQQNumber ? item.encodeQQNumber : item.id
                    }
                    break;
                case 'troop':
                    break;
                case 'discuss':
                    break;
            }
            return result === '' ? result : ` (${result})`;
        }
    },
    {
        type: 'tag',
        value: '</span>'
    }
];

const peopleNameRule = [
    {
        type: 'key',
        value: 'name'
    },
    {
        type: 'tag',
        value: '<span class="list-cell__name-tails">'
    },
    {
        type: 'string',
        value: ' ('
    },
    {
        type: 'function',
        value: item => {
            return item.encodeQQNumber ? item.encodeQQNumber : item.id;
        }
    },
    {
        type: 'string',
        value: ')'
    },
    {
        type: 'tag',
        value: '</span>'
    }
];

export const TAB_DEFAULT_CONFIG = {
    colleague: {
        label: '同事',
        placeholder: '搜索我的同事',
        field: 'colleague',
        sourceType: 'people',
        config: {
            multiLevel: true,
            shouldSelectGroup: true,
            cellNameRule: colleagueNameRule,
            searchNameRule: colleagueNameRule,
            itemMayBeInMulitipleGropus: true,
            loadMore: true, // 旧版本没有分页， 新版本有分页，只能在代码里做应逻辑了
            pageInfo: {
                index: 0
            }
        }
    },

    troop: {
        label: '群',
        placeholder: '搜索我的群',
        field: 'troop',
        sourceType: 'troop'
    },
    //个Q群设置
    Gtroop: {
        label: '群',
        placeholder: '搜索我的群',
        field: 'Gtroop',
        sourceType: 'troop'
    },

    troopMember: {
        label: '群成员',
        placeholder: '搜索我的群成员',
        field: 'troopMember',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            shouldSelectGroup: true,
            searchNameRule: peopleNameRule
        }
    },

    discuss: {
        label: '多人聊天',
        placeholder: '搜索我的多人聊天',
        field: 'discuss',
        sourceType: 'discuss',
        config: {
            displayFace: false,
            searchNameRule: [
                {
                    type: 'key',
                    value: 'name'
                }
            ]
        }
    },

    discussMember: {
        label: '多人聊天成员',
        placeholder: '搜索我的多人聊天成员',
        field: 'discussMember',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule,
            itemMayBeInMulitipleGropus: true
        }
    },

    confGroupMember: {
        label: '初创群成员',
        placeholder: '搜索我的初创群成员',
        field: 'confGroupMember',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule,
            itemMayBeInMulitipleGropus: true
        }
    },

    confGroup: {
        label: '初创群',
        placeholder: '搜索我的初创群',
        field: 'confGroup',
        sourceType: 'discuss',
        config: {
            displayFace: false,
            searchNameRule: [
                {
                    type: 'key',
                    value: 'name'
                }
            ]
        }
    },

    troopMix: {
        label: '群组',
        placeholder: '搜索我的群组',
        field: 'troopMix',
        sourceType: 'troop'
    },

    troopMixMember: {
        label: '群组成员',
        placeholder: '搜索我的群组成员',
        field: 'troopMixMember',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule
        }
    },

    recent: {
        label: '最近联系人',
        placeholder: '搜索我的最近联系人',
        field: 'recent',
        sourceType: ['people', 'troop', 'discuss'],
        config: {
            cellNameRule: recentNameRule,
            searchNameRule: recentNameRule
        }
    },

    QQFriend: {
        label: '我的好友',
        placeholder: '搜索我的好友',
        field: 'QQFriend',
        sourceType: 'people',
        searchLoadMore: true, // 搜索的时候是否支持滚动加载
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule,
            forceLoadDetail: true,
            loadByPaginate: true,
            // loadByPaginate: false,
            multiLevel: false
        }
    },
    //个Q的好友
    GQQFriend: {
        label: '我的好友',
        placeholder: '搜索我的好友',
        field: 'GQQFriend',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule,
            forceLoadDetail: true,
            // loadByPaginate: false,
            multiLevel: false
        }
    },

    cloudPhoneBook: {
        label: '外部联系人',
        placeholder: '搜索外部联系人',
        field: 'cloudPhoneBook',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule
        }
    },

    customer: {
        label: '我的客户',
        placeholder: '搜索我的客户',
        field: 'customer',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule
        }
    },

    groupChat: {
        label: '多人群聊',
        placeholder: '搜索我的多人群聊',
        field: 'groupChat',
        sourceType: 'discuss',
        config: {
            displayFace: false,
            searchNameRule: [
                {
                    type: 'key',
                    value: 'name'
                }
            ]
        }
    },

    groupChatMember: {
        label: '多人群聊成员',
        placeholder: '搜索我的多人群聊成员',
        field: 'groupChatMember',
        sourceType: 'people',
        config: {
            cellNameRule: peopleNameRule,
            searchNameRule: peopleNameRule,
            multiLevel: true,
            itemMayBeInMulitipleGropus: true
        }
    },

    result: {
        label: '结果列表',
        placeholder: '没有搜索',
        field: 'result',
        sourceType: ['people', 'troop', 'discuss'],
        config: {
            cellNameRule: [
                {
                    type: 'key',
                    value: 'name'
                },
                {
                    type: 'function',
                    value: (item) => {
                        let result = '';
                        switch (item.metaSourceType) {
                            case 'people':
                                if (item.colleagueInfo && item.colleagueInfo.account && !item.hiddenSubName) {
                                    result = item.colleagueInfo.account;
                                }
                                break;
                            case 'troop':
                                break;
                            case 'discuss':
                                break;
                        }
                        return result === '' ? result : ` <span>(${result})</span>`;
                    }
                }
            ]
        }
    },

    customeBase:{
        label: '客户库',
        placeholder: '搜索客户库',
        field: 'customeBase',
        sourceType: 'people',
        config: {
            loadMore: true,
            pageInfo:{
                index: -1,
                size: 30
            }
        }
    },
    groupAssistant:{
        label: '机器人',
        placeholder: '搜索机器人',
        field: 'groupAssistant',
        sourceType: 'people'
    },

    companyWeChatOrg:{
        label: '企微通讯录',
        placeholder: '搜索企微通讯录',
        field: 'companyWeChatOrg',
        sourceType: 'people',
        searchLoadMore: true, // 搜索的时候是否支持滚动加载
        config: {
            multiLevel: true
        }
    },
};

export const TAB_SOURCE_TYPE = [
    {
        label: '联系人',
        field: 'people',
        type: {
            0: {
                label: '外部联系人',
                value: 0
            },
            1: {
                label: '同事',
                value: 1
            },
            2: {
                label: '助手号',
                value: 2
            },
            3: {
                label: '通知号',
                value: 3
            },
            4: {
                label: '客服号',
                value: 4
            }
        }
    },
    {
        label: '群',
        field: 'troop',
        type: {
            0: {
                label: '普通群',
                value: 0
            },
            1: {
                label: '内部群',
                value: 1
            },
            2: {
                label: '普通群隐私群',
                value: 2
            },
            3: {
                label: '内部群隐私群',
                value: 3
            }
        }
    },
    {
        label: '群聊',
        field: 'discuss',
        type: {
            0: {
                label: '群聊',
                value: 0
            },
            1: {
                label: '多人聊天',
                value: 1
            }
        }
    }
];
